import { FC } from 'react';

import { layoutTypes, LayoutTypesProps } from './config';

interface IProps {
  variant: 'main';
}

const Layout: FC<IProps & LayoutTypesProps> = ({ variant, ...props }) =>
  layoutTypes(props)[variant];

export default Layout;
